<template>
  <section class="max-w-3xl mx-auto px-4 py-10 space-y-8">
    <header class="space-y-2">
      <h1 class="text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-gray-100">Privacy Policy</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">Last updated: February 12, 2026</p>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        This Privacy Policy explains how Rozay ("we", "our", or "us") handles information when you use
        <a href="https://rozay.today" class="underline hover:no-underline dark:text-gray-200">rozay.today</a>.
      </p>
    </header>

    <div class="space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-6">
      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">1. What We Collect</h2>
        <p>
          We do not offer user accounts, and we do not ask you to submit personal data for normal use of this website.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">2. Analytics</h2>
        <p>
          We may use Google Analytics to understand basic website usage, such as pages visited, approximate location,
          device type, and time spent on pages. This helps us improve the site.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">3. Advertising</h2>
        <p>
          We may use Google AdSense in the future. Ad providers may use cookies to show relevant ads based on your
          browsing behavior, according to their own policies.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">4. Cookies</h2>
        <p>
          Third-party services such as Google Analytics or AdSense may use cookies or similar technologies. You can
          control cookies through your browser settings.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">5. Data Sharing</h2>
        <p>
          We do not sell personal information. We only use trusted third-party services needed to run and improve the
          website.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">6. Children's Privacy</h2>
        <p>
          Rozay is an informational website and is not directed to children under 13. We do not knowingly collect
          personal information from children.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">7. Policy Updates</h2>
        <p>
          We may update this policy when needed. Any changes will be posted on this page with a revised "Last
          updated" date.
        </p>
      </section>
    </div>
  </section>
</template>
